'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Key used for specifying an error message for required fields
 *
 * Example:
 * ```
 * {
 *   path: ['email'],
 *   label: 'Email',
 *   type: 'email',
 *   required: true,
 *   validations: {
 *     [required]: {text: 'A valid email is required'},
 *   },
 * }
 * ```
 */
/**
 * Key used for specifying an error message for required fields
 *
 * Example:
 * ```
 * {
 *   path: ['email'],
 *   label: 'Email',
 *   type: 'email',
 *   required: true,
 *   validations: {
 *     [required]: {text: 'A valid email is required'},
 *   },
 * }
 * ```
 */var required = exports.required = 'required';
/**
 * Validate an input against a regex
 *
 * Example:
 * ```
 * {
 *   path: ['email'],
 *   label: 'Email',
 *   type: 'email',
 *   validations: {
 *     email: {
 *       text: 'The email is invalid',
 *       validation: pattern(emailRegex),
 *     },
 *   },
 * }
 * ```
 */
var pattern = exports.pattern = function pattern(_pattern) {
  return function (value) {
    return _pattern.test(value);
  };
};
//# sourceMappingURL=validation.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./dist/src/validation.js
 ** module id = 182
 ** module chunks = 0
 **/